export default __webpack_public_path__ + "static/media/Layout t2 - Segregação Arm.05 rev 29.9725890e.pdf";